var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundedCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM17.39 17.76C17.39 18.15 17.08 18.46 16.69 18.46H7.31C6.92 18.46 6.61 18.15 6.61 17.76V10.92H17.38V17.76H17.39ZM17.39 9.85H6.61V8.4C6.61 8.01 6.92 7.7 7.31 7.7H8.76V5.55H9.84V7.7H14.15V5.55H15.23V7.7H16.68C17.07 7.7 17.38 8.01 17.38 8.4V9.85H17.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundedCalendar);
export default __webpack_public_path__ + "static/media/ic-rounded-calendar.c8ce16b5a13b7eef603f89c29be2e314.svg";
export { ForwardRef as ReactComponent };